import React, { Component } from 'react';

import DateRangesDropdown from '../../base/dropdowns/dateranges-dropdown';
import { Loader, NoResult } from '../../misc/loader-utils';
import Graph from './graph';

class LinksGraph extends Component {
  constructor(props) {
    super(props);

    const defaultRange = this.props.rangeDropdownItems.find(item => item.selected);
    this.state = {
      selectedRange: defaultRange,
    };
  }

  updateRange(rangeDropdownItems) {
    const selectedRange = rangeDropdownItems.find(item => item.selected);
    this.setState({ selectedRange });
  }

  render() {
    const rangeType = this.state.selectedRange.name;
    const dateRanges = (
      <DateRangesDropdown
        gaEvent={{
          category: 'Publisher Dashboard',
          label: `${this.state.graphType} Date Range`,
        }}
        items={this.props.rangeDropdownItems}
        updateRange={updatedItems => this.updateRange(updatedItems)}
      />
    );
    const graph =
      !this.props.loading && !this.props.showNoResult ? (
        <Graph
          data={this.props.graphDataByRange[rangeType]}
          projections={{}}
          graphType="count_per_date"
          rangeType={rangeType}
          graphLabelMap={{ count_per_date: 'Links' }}
        />
      ) : null;

    return (
      <div className="links-graph">
        <div className="header">
          <div className="title">
            <span className="color-block"></span>
            <span className="text">Links Created</span>
          </div>
          {dateRanges}
        </div>
        <Loader loading={this.props.loading} />
        <NoResult type="earnings-graph" noResult={!this.props.loading && this.props.showNoResult} />
        {graph}
      </div>
    );
  }
}

export default LinksGraph;
